import { render, staticRenderFns } from "./cash-up.vue?vue&type=template&id=e2472f5c&scoped=true&"
import script from "./cash-up.vue?vue&type=script&lang=js&"
export * from "./cash-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2472f5c",
  null
  
)

export default component.exports